import React, { useContext } from 'react';

// import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import s from './HeroOrganization.module.scss';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import Image from 'next/image';
import { GradientContext } from '../../containers/BasePage';

const HeroOrganization = ({
  tagline,
  titleTop,
  titleBottom,
  text,
  link,
  modifiers = [],
}) => {
  const gradient = useContext(GradientContext);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const classes = classNames(
    s.Root,
    {
      [s.Visible]: inView,
    },
    s[gradient],
    modifiers.map((m) => s[m])
  );

  return (
    <div className={classes} ref={ref}>
      <div className={s.Container}>
        <div className={s.Left}>
          {tagline && <div className={s.Tagline}>{tagline}</div>}
          <h1 className={s.TitleContainer}>
            <span className={s.TitleTop}>{titleTop}</span>
            <span className={s.TitleBottom}>{titleBottom}</span>
          </h1>
        </div>
        <div className={s.Right}>
          {text && <p className={s.Text}>{text}</p>}
          {link?.href && (
            <div className={s.LinkWrapper}>
              <a className={s.LinkContainer} href={link.href}>
                <div className={s.IconWrapper}>
                  <Image
                    width={24}
                    height={24}
                    src={`/img/icon-arrow-right-white.svg`}
                    alt=""
                    className={s.Icon}
                  />
                </div>
                <span className={s.LinkText}>{link.text}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

HeroOrganization.propTypes = {};

export default HeroOrganization;
